var _path, _path2, _g, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorBoxNew = function SvgErrorBoxNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 120,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Error_BoxNew_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.684 73.192c1.744 1.755 3.439 3.578 5.261 5.255 1.182 1.091 1.201 1.813 0 2.963-7.732 7.41-16.53 13.162-26.567 16.789-25.627 9.272-49.994 6.493-72.889-8.316-3.798-2.457-7.092-5.713-10.629-8.57-1.114-.907-1.153-1.628-.077-2.671 3.73-3.656 7.392-7.38 11.045-11.115.97-.975 1.638-1.101 2.723-.068 7.848 7.41 16.975 12.538 27.497 14.839 20.191 4.426 38.26-.088 53.986-13.669 2.732-2.36 2.693-2.398 5.222.127l4.418 4.445z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Error_BoxNew_svg__b",
    width: 208,
    height: 113,
    x: -48,
    y: -9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.81 103.616c-25.07 0-43.704-12.196-48.786-16.94L-47.5 36.492 60.81-9 159.7 31l-48.746 54.999c-16.601 14.229-40.316 17.617-50.142 17.617"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Error_BoxNew_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F45149",
    d: "M18.842 20.032a.71.71 0 0 0 .047.79L29.274 35.25a.73.73 0 0 0 .912.225.8.8 0 0 0 .22-.174l3.7-4.183 3.971 1.799a.67.67 0 0 0 .618-.015.6.6 0 0 0 .206-.153.7.7 0 0 0 .193-.395.7.7 0 0 0-.065-.432l-1.763-3.57-14.197-6.474 15.618 4.067 3.223-3.654q.31-.329.13-.766-.18-.42-.627-.443l-21.884-1.418a.715.715 0 0 0-.688.368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C9",
    d: "m43.2 53.3-21-3.5s5 11.5 3 14.5l22 2.5c1-3.5-4-13.5-4-13.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M25.5 64h55v44h-55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFC4CF",
    d: "M78.245 83.703 81 63.5 75.5 77l-50-.5v7l50.687 1.93a2 2 0 0 0 2.058-1.727",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACED7",
    d: "M80.2 107.3v-44l20.999-3.5v37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "m101 60-21 3.5s4.5-12 2.5-15l22-2.5c1 3.5-3.5 14-3.5 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE1E9",
    d: "m81 63.3-55.5.5-3.379 13.515a2 2 0 0 0 1.94 2.485h50.932c.892 0 1.675-.587 1.918-1.445.864-3.046 2.885-10.24 4.089-15.055"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6793E0",
    d: "m96.103 74.789-9.455 2.206a2.81 2.81 0 1 1-1.222-5.486l9.498-2.014a2.712 2.712 0 0 1 1.18 5.294"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.513,
    d: "M65.68 49.626s-9.787-8.333-18.07-6.848c-8.281 1.486 1.099 11.502 5.788 6.454s4.196-15.91-11.897-18.54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.52,
    d: "M74.887 52.287 79.28 36.88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Error_BoxNew_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h120v120H.5z"
  })))));
};
export default SvgErrorBoxNew;